// extracted by mini-css-extract-plugin
module.exports = {"Free":"Free--3c3vC"};